"use strict";
/**
 * executes shared logic to boot client app via `react-engine`'s `client.boot()`
 */
Object.defineProperty(exports, "__esModule", { value: true });
// just importing this for the side-effect of executing the contained function so it can do its thing
require("adsinterceptor");
require("vxlib");
require("ppvxCore");
require("overflowMenu");
require("overflowAdmin");
require("babel-polyfill/browser.js");
var React = require("react"); // eslint-disable-line no-unused-vars
var store_1 = require("./store");
var analytics_1 = require("./utils/fpti/analytics");
var rehydrate_1 = require("./rehydrate");
var client_error_logger_1 = require("./utils/logging/client-error-logger");
var routes_client_1 = require("./routes.client");
var opinion_lab_component_1 = require("./utils/feedback/opinion-lab-component");
var route_utils_1 = require("./route.utils");
// webpack does not like require('./routes.server'). It will go into recursive loop - OOM
var app_view_1 = require("./app-view"); // eslint-disable-line no-unused-vars
/**
 * Executes shared logic to boot client app via `react-engine`'s `client.boot()`
 */
window.addEventListener("load", function () {
    var clientStore;
    // react-engine set up script tag id="react-engine-props" before </body> tag for server model/store
    // then uses that to provide the serverStore here
    rehydrate_1.rehydrate(
    // boot options
    {
        /**
         * @function viewResolver - returns a function that `react-engine` can use to render the client code
         * with server data
         * @returns { Function }
         */
        viewResolver: function viewResolver(view) {
            return function (serverStore) {
                // Create client store hydrated with server store
                clientStore = store_1.createNewStore(serverStore);
                return React.createElement(app_view_1.AppView, { store: clientStore });
            };
        },
    }, 
    // boot callback
    function onBoot(data) {
        analytics_1.default(data); // expects raw data from server
        client_error_logger_1.default.start(clientStore, "/flow/error");
        routes_client_1.default(clientStore);
        route_utils_1.transitionInHandler();
        var _a = clientStore.getState().route, _b = (_a === void 0 ? {} : _a).isFlow, isFlow = _b === void 0 ? false : _b;
        if (!isFlow) {
            // Initialize feedback link component only when rendering full app
            // The error page and flows dont have footer,
            // which cause an error in the opinion lab code, which causes an error loop
            if (data.route.enter.view !== "globalError") {
                opinion_lab_component_1.default(data);
            }
        }
    });
});
